import { axiosApi } from './apiEnviornment';
import { getEnvValue } from './envHelper';

const PRICE_DOCUMENT_ID =
  getEnvValue('VITE_PRICE_DOCUMENT_ID') ||
  getEnvValue('REACT_APP_PRICE_DOCUMENT_ID') ||
  '65d644ede3bb7736ea13f9c7';

const params = { deleted: true };
const queryString = Object.keys(params)
  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');

// GET
export const getPRCount = () => axiosApi('GET', `/sale/get-sale-count`);
export const getJobs = (status) => axiosApi('GET', `/sale/get-all-sale?status=${status}`);
export const getCanceledJobs = () => axiosApi('GET', `/cancel/get-all-cancel`);
export const getTrashData = () => axiosApi('GET', `/sale/get-all-sale?${queryString}`);
export const getSalesData = (id) => axiosApi('GET', `/sale/get-sale-by-id/${id}`);
export const getPrice = () => axiosApi('GET', `/price/get-price-by-id/${PRICE_DOCUMENT_ID}`);
export const getCoordinates = (point, placeId) =>
  axiosApi('GET', `/map/get-coordinates/${placeId}/${point}`);
export const getNotificationCount = () => axiosApi('GET', `/notification/get-notification-count`);
export const getNotificationArray = () => axiosApi('GET', `/notification/get-all-notification`);
export const getDrivers = () => axiosApi('GET', '/employee/drivers');

// Emails
export const sendBrevoTemplate = (bookingId, templateId, recipientEmail = null) => {
  const payload = { templateId };
  if (recipientEmail) {
    payload.recipientEmail = recipientEmail;
  }
  return axiosApi('POST', `/sale/${bookingId}/send-email`, payload);
};

// Sends the Wrapping-Up customer payment request email(s) + SMS without changing status
export const sendPaymentRequest = (bookingId) =>
  axiosApi('POST', `/sale/${bookingId}/send-payment-request`, {});

// Item categories (now accepts options object: { headers, signal })
export const getItemCategoriesData = ({ headers = {}, signal } = {}) =>
  axiosApi('GET', `/settings/item-categories`, {}, { headers, raw: true, signal });

export const getPriceData = () => axiosApi('GET', `/price/get-price-by-id/${PRICE_DOCUMENT_ID}`);

// PUT
export const restoreBooking = (id, body) => axiosApi('PUT', `/sale/update-sale-by-id/${id}`, body);
export const updateBooking = (id, body) => axiosApi('PUT', `/sale/update-sale-by-id/${id}`, body);
export const changeNotificationStatus = (id, body) =>
  axiosApi('PUT', `/notification/update-notification-by-id/${id}`, body);
export const updatePriceData = (body) =>
  axiosApi('PUT', `/price/update-price-by-id/${PRICE_DOCUMENT_ID}`, body);

// Strict items update (kept compatible; now also accepts { headers, signal })
export const updateItemCategoriesData = (body, { headers = {}, signal } = {}) =>
  axiosApi('PUT', `/settings/item-categories`, body, { headers, raw: true, signal });

// DELETE
export const deleteBooking = (id) => axiosApi('DELETE', `/sale/delete-sale-by-id/${id}`);

// Permissions
export const getPermissions = () => axiosApi('GET', `/settings/permissions`);
export const updatePermissions = (permissionsMap) =>
  axiosApi('PUT', `/settings/permissions`, permissionsMap);

// Activity Log
export const getActivityLogs = ({ limit = 50, before, bookingId, action } = {}) => {
  const params = {};
  if (limit) params.limit = limit;
  if (before) params.before = before;
  if (bookingId) params.bookingId = bookingId;
  if (action) params.action = action;
  return axiosApi('GET', `/activity-log`, {}, { params });
};

export const getActivityLogsByBooking = (bookingId, { limit = 50, before } = {}) => {
  const params = {};
  if (limit) params.limit = limit;
  if (before) params.before = before;
  return axiosApi('GET', `/activity-log/booking/${bookingId}`, {}, { params });
};

// Email Notification Settings
export const getEmailNotificationSettings = () => axiosApi('GET', `/email-notification-settings`);

export const getEmailGlobalSettings = () => axiosApi('GET', '/email-notification-settings/global');

export const updateEmailGlobalSettings = (data) =>
  axiosApi('PUT', '/email-notification-settings/global', data);

export const createEmailNotificationSetting = (data) =>
  axiosApi('POST', `/email-notification-settings`, data);

export const updateEmailNotificationSetting = (id, data) =>
  axiosApi('PUT', `/email-notification-settings/${id}`, data);

export const deleteEmailNotificationSetting = (id) =>
  axiosApi('DELETE', `/email-notification-settings/${id}`);

// SMS Notification Settings
export const getSMSNotificationSettings = () => axiosApi('GET', `/sms-notification-settings`);

export const createSMSNotificationSetting = (data) =>
  axiosApi('POST', `/sms-notification-settings`, data);

export const updateSMSNotificationSetting = (id, data) =>
  axiosApi('PUT', `/sms-notification-settings/${id}`, data);

export const deleteSMSNotificationSetting = (id) =>
  axiosApi('DELETE', `/sms-notification-settings/${id}`);

// Van Capacity
export const getSmallestVanCapacity = () => axiosApi('GET', `/price/get-smallest-van-capacity`);

// Stripe integration via backend proxy
export const validateStripeKey = (apiKey) => 
  axiosApi('POST', '/stripe/validate-key', { apiKey });

export const getStripeCharges = (apiKey, startMs, endMs) => 
  axiosApi('POST', '/stripe/charges', { apiKey, startMs, endMs });

// Google Sheets integration
export const syncGoogleSheetsValue = (spreadsheetUrl, sheetName, cellId) =>
  axiosApi('POST', '/google-sheets/sync', { spreadsheetUrl, sheetName, cellId });

// Resolve a short booking code (e.g. from an SMS {{crmLink}}) to a booking ID
export const resolveShortBookingCode = (code) =>
  axiosApi('GET', `/sale/resolve-short/${encodeURIComponent(code)}`);

// Payment tracking
export const getBookingPayments = (bookingId) => 
  axiosApi('GET', `/sale/${bookingId}/payments`);

// Server-side price calculation (Backend-V1 authoritative pricing endpoint)
export const calculatePriceFromServer = (body) =>
  axiosApi('POST', `/sale/calculate-price`, body);

// Voice call logs
export const getVoiceCallLogs = ({ page = 1, limit = 20 } = {}) =>
  axiosApi('GET', `/voice-call-logs`, {}, { params: { page, limit } });
